// src/hooks/useInvoiceModal.js
import { useCallback, useMemo, useState } from "react";
import CreateInvoiceModal from "../modals/CreateInvoiceModal";

export default function useInvoiceModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [showParams, setShowParams] = useState({});

  const hide = useCallback(() => {
    setIsOpen(false);
    setShowParams({});
  }, []);

  const show = useCallback((params = {}) => {
    setShowParams(params);
    setIsOpen(true);
  }, []);

  const createInvoiceModal = useMemo(
    () => ({
      show,
      hide,
      isOpen,
    }),
    [show, hide, isOpen]
  );

  // Renderuj raz w komponencie-stronie (np. na dole JSX-a)
  const CreateInvoiceModalRoot = useCallback(() => {
    return (
      <CreateInvoiceModal
        show={isOpen}
        onHide={hide}
        {...showParams}
      />
    );
  }, [isOpen, hide, showParams]);

  return { createInvoiceModal, CreateInvoiceModal: CreateInvoiceModalRoot };
}
